import React, { useEffect, useState } from 'react';
import { Grid, CardContent, Typography } from '@mui/material';
import { formatDollar, formatPercentageNoDecimal } from '../utilityFunctions';

const RevenueSpreadCard = ({ revenueSpreadData }) => {
	const [data, setData] = useState(revenueSpreadData);

	useEffect(() => {
		setData(revenueSpreadData);
	}, [revenueSpreadData]);

	const today = new Date();
	const currentYear = today.getMonth() === 0 ? today.getFullYear() - 1 : today.getFullYear();

	// Provide default values to prevent NaN
	const {
		sfdc_total_revenue = 0,
		sfdc_off_the_books_revenue = 0,
		revenue_allocations = [],
	} = data;

	const unearned_revenue = sfdc_total_revenue - sfdc_off_the_books_revenue;
	const revenueSpread = revenue_allocations.map((item) => ({
		year: item.year,
		amount: unearned_revenue * (item.projected_percent / 100),
		percentage: item.projected_percent,
	}));

	const renderRevenueItem = (title, value) => (
		<Grid size={{ xs: 4 }}>
			<Typography variant="subtitle1" className="sf-card-title-medium" sx={{ textAlign: 'center' }}>
				{title}
			</Typography>
			<Typography sx={{ textAlign: 'center' }} className="main-key-project-info-body">
				{formatDollar(value) || '--'}
			</Typography>
		</Grid>
	);

	return (
		<CardContent sx={{ margin: '-25px -10px 30px -10px' }}>
			<Grid container spacing={{ xs: 2 }} sx={{ width: '100%', justifyContent: 'center' }}>
				{renderRevenueItem('Total Revenue', sfdc_total_revenue)}
				{renderRevenueItem('Earned in Prior Years', sfdc_off_the_books_revenue)}
				{renderRevenueItem('Unearned Revenue', unearned_revenue)}

				<Grid size={{ xs: 12 }} sx={{ padding: '0px', marginTop: '-10px' }}>
					<Typography variant="subtitle1" className="sf-card-title-medium-2" sx={{ textAlign: 'center' }}>
						Unearned Revenue Spread:
					</Typography>
				</Grid>
				

				{revenueSpread.map(({ year, amount, percentage }, index) => (
					<Grid size={{ xs: 3 }} key={index}>
						<Typography variant="subtitle1" className="sf-card-title-medium" sx={{ textAlign: 'center' }}>
							{year}
						</Typography>
						<Typography sx={{ textAlign: 'center' }} className="main-key-project-info-body">
							{formatDollar(amount) || '--'}
						</Typography>
						<Typography sx={{ textAlign: 'center' }} className="ppsf-mini">
							{formatPercentageNoDecimal(percentage)}
						</Typography>
					</Grid>
				))}
			</Grid>
		</CardContent>
	);
};

export default RevenueSpreadCard;